import React from 'react';
import UserProfileDetails from './ProfileDetails';

const UserProfile = () => {
    return (
        <UserProfileDetails />
    );
};

export default UserProfile;
